import React from 'react';

import { Box, FormControlLabel, Radio, Typography } from '@mui/material';

import { CollectionReasonKey } from '~/consts/refund';

export function RefundReasonRadio({
  refundReasonKey,
  label,
  description,
}: {
  refundReasonKey: CollectionReasonKey;
  label: string;
  description: string;
}) {
  return (
    <FormControlLabel
      sx={{
        marginY: 0.5,
        marginRight: 0,
        minWidth: '100%',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      }}
      value={refundReasonKey}
      control={
        <Radio
          inputProps={{
            required: true,
          }}
        />
      }
      label={
        <Box paddingY={0.5}>
          <Typography fontWeight="bold" component="span" display="block">
            {label ?? refundReasonKey}
          </Typography>
          <Typography component="span" display="block">
            {description}
          </Typography>
        </Box>
      }
      disableTypography
    />
  );
}
